'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_SHARED_USER_FORM_FIELDS = exports.ADD_SHARED_USER_FORM_NAME = undefined;

var _validationConstants = require('../../../../../../common/validation/validationConstants');

var ADD_SHARED_USER_FORM_NAME = exports.ADD_SHARED_USER_FORM_NAME = 'addSharedUser'; // Constants
var ADD_SHARED_USER_FORM_FIELDS = exports.ADD_SHARED_USER_FORM_FIELDS = _validationConstants.ADD_SHARED_USER_FIELDS;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/form/boardSharingFormConstants.js
// module id = 477
// module chunks = 0